/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "appApi",
            "endpoint": "https://cp3ocdoqa8.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        },
        {
            "name": "publicApi",
            "endpoint": "https://e881o7s316.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:14bd246c-2fb8-4524-b486-e8d2fcfb5477",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_9qQk89Tib",
    "aws_user_pools_web_client_id": "6hgrttlpnhjh2np2l36foumvof",
    "oauth": {
        "domain": "primaryrecord52ec7167-52ec7167-prod.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "primary-record-app://,exp://127.0.0.1:8081/--/,https://www.primaryrecord.app/,https://dev.primaryrecord.app/,http://localhost:19006",
        "redirectSignOut": "exp://127.0.0.1:8081/--/,primary-record-app://,https://www.primaryrecord.app/,https://dev.primaryrecord.app/,http://localhost:19006",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE",
        "APPLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "ABACRuleSets-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "AuditLogComments-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "AuditLogs-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "CareTeamMemberRelationships-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "CareTeamMembers-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "ChatMessages-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "ContactDetails-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "MedicalProfileCollaboratorInvites-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "MedicalProfileCollaborators-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "MedicalProfileFileArtifacts-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "MedicalProfileFileFolders-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "MedicalProfileFiles-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "MedicalProfileIdCards-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "MedicalProfileInsuranceCards-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "MedicalProfileOwnershipTransfers-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "MedicalProfileRefreshProgress-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "MedicalProfileUsageMetrics-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "MedicalProfiles-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "NoteComments-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "Notes-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "OneUpHealthSystemConnections-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "OneUpHealthUsers-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "OrganizationClientInvitations-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "OrganizationClientRecords-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "OrganizationGroupMedicalProfiles-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "OrganizationGroupUsers-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "OrganizationGroups-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "OrganizationInvitationDefinitions-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "OrganizationStripeAccounts-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "OrganizationUsageMetrics-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "OrganizationUserInvitations-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "OrganizationUsers-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "Organizations-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "PDFMonkeyProcessingRecord-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "PaymentWebhookEvents-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "RecurringTasks-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "RegistrationCodes-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "ResourceCareTeamMembers-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "ResourceRecords-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "ResourceRelationships-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "ScheduledJobs-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "SearchState-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "SharedReportViews-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "SharedReports-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "StripeCustomers-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "UserIdLookup-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "UserMedicalProfileChats-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "UserPreferences-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "UserProducts-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "UserRegistrationCodes-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "UserSubLookupCache-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "Users-prod",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
